import api from './client';

export interface Organizacao {
  id: number;
  razaoSocial?: string;
  nomeFantasia?: string;
  cnpj?: string;
  inscricaoEstadual?: string;
  telefone?: string;
  celular?: string;
  email?: string;
  site?: string;
  endereco?: string;
  numero?: string;
  bairro?: string;
  cidade?: string;
  estado?: string;
  cep?: string;
  logoBase64?: string;
}

class OrganizacaoApi {
  async obter(): Promise<Organizacao> {
    const r = await api.get<Organizacao>('/organizacao');
    return r.data;
  }

  async salvar(dados: Organizacao): Promise<void> {
    await api.put('/organizacao', dados);
  }

  async uploadLogo(arquivo: File): Promise<string> {
    const form = new FormData();
    form.append('arquivo', arquivo);
    const r = await api.post<{ logoBase64: string }>('/organizacao/logo', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return r.data.logoBase64;
  }
}

export const organizacaoApi = new OrganizacaoApi();
